import { formatSpeed } from "@/utils/utils";
export class NodeDownload {
  constructor(node, token, timeout, filesize) {
    this.url = `${node.scheme}://${node.host}:${node.port}/download?token=${token}&filesize=${filesize}`;
    console.log("new NodeDownload", `${node.host}:${node.port}`);
    this.ping = 0;
    this.requestTick = 0;
    this.lastloaded = 0;
    this.onload = null;
    this.onerror = null;
    this.ontimeout = null;
    this.onprogress = null;
    this.onping = null;

    const xhr = (this.xhr = new XMLHttpRequest());
    xhr.timeout = timeout;
    xhr.onreadystatechange = (e) => {
      const xhr = e.target;
      if (xhr.readyState === 2) {
        this.ping = Date.now() - this.requestTick;
        if (this.onping) this.onping(this.ping);
      }
    };
    xhr.onprogress = (e) => {
      if (!e.lengthComputable) return;

      const bytes = e.loaded - this.lastloaded;
      this.lastloaded = e.loaded;
      if (this.onprogress) this.onprogress(bytes);
    };
    xhr.ontimeout = () => {
      if (this.ontimeout) this.ontimeout();
    };
    xhr.onload = () => {
      if (this.onload) this.onload();
    };
    xhr.onerror = () => {
      if (this.onerror) this.onerror();
    };
    // xhr.onabort = () => {
    //   console.log("abort");
    // };
    // xhr.onloadstart = () => {
    //   console.log("loadstart");
    // };
    // xhr.onloadend = () => {
    //   console.log("loadend");
    // };
  }

  request() {
    this.xhr.open("GET", this.url);
    this.xhr.send();
    this.ping = 0;
    this.lastloaded = 0;
    this.requestTick = Date.now();
  }

  cancel() {
    this.xhr.abort();
  }
}

export class NodeUpload {
  constructor(node, token, timeout) {
    this.url = `${node.scheme}://${node.host}:${
      node.port
    }/upload?token=${token}&r=${Math.random()}`;
    console.log("new NodeUpload", `${node.host}:${node.port}`);
    this.onload = null;
    this.onprogress = null;
    this.onerror = null;
    this.ontimeout = null;
    this.lastloaded = 0;

    const xhr = (this.xhr = new XMLHttpRequest());
    xhr.timeout = timeout;
    xhr.onload = (e) => {
      if (this.onload) this.onload();
    };
    xhr.upload.onprogress = (e) => {
      if (!e.lengthComputable) return;
      const bytes = e.loaded - this.lastloaded;
      this.lastloaded = e.loaded;
      if (this.onprogress) this.onprogress(bytes);
    };
    xhr.upload.onabort = () => {
      console.log("upload abort");
    };
    xhr.upload.onerror = (e) => {
      console.log("upload error");
      if (this.onerror) this.onerror();
    };
    // xhr.upload.onloadstart = () => {
    //     console.log('upload loadstart');
    // }
    // xhr.upload.onloadend = () => {
    //     console.log('upload loadend');
    // }
    xhr.upload.ontimeout = () => {
      console.log("upload timeout");
      if (this.ontimeout) this.ontimeout();
    };
  }

  static requestSize = 256 * 1024;

  request() {
    this.xhr.open("POST", this.url);
    this.xhr.setRequestHeader("Content-Type", "application/octet-stream");
    this.lastloaded = 0;
    const buffer = new ArrayBuffer(NodeUpload.requestSize);
    const data = new Uint32Array(buffer);
    const base = Math.pow(2, 32) - 1;
    for (let i = 0, len = data.length; i < len; i++) {
      data[i] = Math.random * base;
    }
    this.xhr.send(new Blob([data]));
  }

  cancel() {
    this.xhr.abort();
  }
}

export class NodeManager {
  constructor() {
    const xhr = (this.xhr = new XMLHttpRequest());
    // this.url = "http://tw19332.sandai.net:3001/getnodes";
    this.url = "http://api-speedtest.onethingpcs.com/api/get_nodes";
    this.onData = null;
    this.onError = null;

    this.resolve = null;
    this.reject = null;

    xhr.onload = (e) => {
      const xhr = e.target;
      // console.log('data', xhr.response);
      const data = JSON.parse(xhr.response);
      if (this.resolve) this.resolve(data);
      if (this.onData) this.onData(data);
    };
    xhr.onerror = (e) => {
      console.log("NodeManager onerror", e);
      if (this.reject) this.reject(e);
      if (this.onError) this.onError(e);
    };
  }

  getNodes(num) {
    const xhr = this.xhr;
    if (xhr.readyState !== 0 && xhr.readyState !== 4) return;
    xhr.open("GET", `${this.url}?nodesnum=${num}`);
    xhr.send();

    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
}

export class SpeedCalculator {
  constructor(cycle, precision = 1000) {
    this._samples = {};
    this._cycle = cycle;
    this._precision = precision;
  }

  addBytes(bytes) {
    const curTick = Math.floor(Date.now() / this._precision);
    this._clean(curTick);
    this._samples[curTick] += bytes;
  }

  calculate() {
    const curTick = Math.floor(Date.now() / this._precision);
    this._clean(curTick);
    let total = 0;
    let size = 0;
    Object.keys(this._samples).forEach((tick) => {
      if (parseInt(tick, 10) === curTick) return;
      total += this._samples[tick];
      size++;
    });
    return size === 0 ? 0 : (total / size) * (1000 / this._precision);
  }

  _clean(targetTick) {
    Object.keys(this._samples).forEach((tick) => {
      if (parseInt(tick, 10) + this._cycle <= targetTick)
        delete this._samples[tick];
    });

    for (let tick = targetTick; tick > targetTick - this._cycle; tick--) {
      if (this._samples[tick] === undefined) this._samples[tick] = 0;
    }
  }
}

export const reportResult = function (result) {
  const xhr = new XMLHttpRequest();

  const search = new URLSearchParams();
  search.append("ip", result.ip);
  search.append("download_bandwidth", formatSpeed(result.downloadSpeed));
  search.append("up_bandwidth", formatSpeed(result.uploadSpeed));
  search.append("delay", Math.floor(result.ping / 2));
  search.append("time", result.ts);
  search.append("location", result.location);
  search.append("isp", result.isp);
  const url = "http://api-speedtest.onethingpcs.com/api/upload_record";
  xhr.open("GET", `${url}?${search}`);
  xhr.send();
};
